<template>
  <button class="text-left flex items-center focus:outline-none" :class="{
    'shadow-md': !simple,
    'bg-card': !simple,
    'rounded-lg': !simple,
    'my-2': !simple
    }" @click="emit()">
    <span class="flex-1 px-3 py-4" :class="{ 'font-bold': checked }">
      <slot />
    </span>
    <span class="pr-3" v-if="showCheck" >
      <svg v-if="checked" xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45"><path d="M959.021,845.945a.683.683,0,0,0-.966,0l-22.408,22.407-8.706-8.705a.683.683,0,0,0-.966.967l9.189,9.189a.683.683,0,0,0,.966,0l22.891-22.891A.684.684,0,0,0,959.021,845.945Z" transform="translate(-919.237 -834.802)" /></svg>
    </span>
  </button>
</template>

<script>
export default {
  props: {
    value: [Boolean, String],
    radio: String,
    unclickable: Boolean,
    simple: Boolean,
    showCheck: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    checked() {
      if(this.radio) {
        return this.value == this.radio
      } else {
        return this.value
      }
    }
  },

  methods: {
    emit() {
      if(this.unclickable) return
      
      if(this.radio) {
        this.$emit('input', this.radio)
      } else {
        this.$emit('input', !this.value)
      }
    }
  }
}
</script>

<style>

</style>